import styled, { css } from 'styled-components';
import { widgetNavIsHidden } from '../../../helpers/widget';

const getTopPosition = (props, isMobile?) => {
  if (widgetNavIsHidden(props)) {
    return props.isPeriodical ? 42 : 0;
  }

  let top = 0;

  if (props.isPeriodical) {
    top += 18;
  }

  if (isMobile) {
    return top + 88;
  }

  return top + 65;
};

interface ContainerProps {
  isHidden: boolean;
  isFullscreen: boolean;
  isPeriodical: boolean;
}

export default {
  Container: styled.div<ContainerProps>`
    display: ${(props) => (props.isHidden ? 'none' : 'block')};
    position: absolute;
    top: ${(props) => getTopPosition(props)}px;
    left: 0;
    background: white;
    overflow: hidden;
    border: 15px solid rgb(255, 255, 255);
    z-index: 4;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
    border-bottom-right-radius: 10px;

    @media screen and (max-width: 700px) {
      top: ${(props) => getTopPosition(props, true)}px;
      z-index: 10;
    }

    ${(props) =>
      props.theme.isRtl &&
      css`
        left: unset;
        right: 0;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 10px;
      `}
  `,

  CurrentPosition: styled.div<any>`
    width: 10px;
    height: 10px;
    background: rgba(255, 218, 0, 0.32);
    position: absolute;
    z-index: 99;
  `,

  Minimap: styled.div`
    line-height: 0;

    path {
      fill: #f5f5f5 !important;
      stroke: white !important;
      stroke-width: 50 !important;
      stroke-linecap: butt !important;
    }
  `,
};
